<template>
  <v-dialog class="rounded-xl" max-width="700" v-model="termsModal">
    <v-card light class="rounded-xl">
      <v-toolbar dark color="primary">
        <v-card-title class="mx-auto text-center">
          Terms and Conditions
        </v-card-title>
      </v-toolbar>
      <v-card-text v-html="termsContent" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="rounded-xl ma-2"
          @click="termsModal = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TermsAndConditionsModal",

  props: ["value"],

  data() {
    return {
      termsContent: "",
    };
  },

  computed: {
    termsModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  async mounted() {
    const res = await fetch("/terms-and-conditions.html");
    this.termsContent = await res.text();
  },
};
</script>
